import angular from 'angular';
import SentMessagesListComponent from './sent-messages-list-component';

export default angular.module('sent-messages-list', []).component('sentMessagesList', new SentMessagesListComponent());



// WEBPACK FOOTER //
// ./src/modules/message/components/sent-messages-list/sent-messages-list-module.js